<template>
  <div v-if="policyData" class="policy-detail-box">
    <div class="policy-detail-content">
      <div class="detail-title">
        <div class="detail-policy-status">
          {{ policyData.payStatus | payStatus }}，{{
            policyData.policyStatus | policyStatus
          }}
        </div>
        <div class="expiry-date">
          保险期间：{{ policyData.timeCommencement | shortDate }} 至
          {{ policyData.timeTermination | shortDate }}
        </div>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list" :border="false">
          <van-cell class="oblong">
            <template #title>
              <span class="rder-role">购买人</span>
            </template>
          </van-cell>
          <van-cell class="cell-title-text fullname" value-class="black-text" title="姓 名">
            {{ policyData.applicantName }}
          </van-cell>
          <van-cell v-if="policyData.isBatchInsured !== '1'" class="cell-title-text" title="证件号码"
            value-class="black-text">
            {{ policyData.applicantCardNo }}
          </van-cell>
          <van-cell v-if="policyData.isBatchInsured !== '1'" class="cell-title-text" value-class="black-text"
            title="手 机 号">
            {{ policyData.applicantMobile }}
          </van-cell>
        </van-cell-group>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list" :border="false">
          <van-cell class="oblong">
            <template #title>
              <span class="rder-role">参保人</span>
            </template>
          </van-cell>
          <van-cell class="cell-title-text fullname" value-class="black-text" title="姓 名">
            {{ policyData.insuredPersonName }}
          </van-cell>
          <van-cell class="cell-title-text" title="证件号码" value-class="black-text">
            {{ policyData.insuredPersonCardNo }}
          </van-cell>
        </van-cell-group>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list margin-bottom-none" :border="false">
          <van-cell class="oblong">
            <template #title>
              <span class="rder-role">保单信息</span>
            </template>
          </van-cell>
          <van-cell class="cell-title-text" title="保单号" :value="policyData.policyNo" value-class="black-text" />
        </van-cell-group>
      </div>
      <!-- <div class="btn-group" v-if="channelSignCode === 'Q8vO3gQn4EQnR3fw'">
        <div id="Personal_Center_Chargeback" class="btn-div" @click="refundBtn">
          <span>退单</span>
        </div>
      </div> -->
      <div class="btn-group" v-if="policyData.channelCode === 'yxhb00000317' &&
        policyData.policyPdfUrl
        ">
        <div id="Personal_Center_Chargeback" class="btn-div" @click="getPersonPolicyPdf">
          <span>获取电子保单</span>
        </div>
      </div>
    </div>
    <!-- <main-menu />  退款 -->
    <van-overlay :show="refundFlag" @click="refundFlag = false">
      <div class="refund-comtent" @click.stop>
        <div class="refund-title">请验证购买人手机号</div>
        <van-field v-model.trim="appntMobileNumber" name="appntMobileNumber" label="手机号" placeholder="手机号" type="number"
          @blur="checkPhone" :error-message="errMsg.mobilePhone" clearable
          :rules="[{ required: true, message: '请填写手机号' }]" />
        <van-field v-model.trim="captcha" name="captcha" label="验证码" placeholder="验证码" type="number" maxlength="6"
          clearable @blur="checkVeriCode" :error-message="errMsg.captcha"
          :rules="[{ required: true, message: '请填写验证码' }]">
          <van-button slot="button" class="code-btn" size="small" :class="{ 'disable-btn': isDisable }" type="info"
            @click.prevent="sendVeriCode">
            {{ captchaText }}
          </van-button>
        </van-field>
        <div class="refund-btn-group" style="margin: 16px">
          <van-button size="small" type="default" class="cancel-btn" round @click="refundFlag = false">
            取消
          </van-button>
          <van-button size="small" class="submit-btn" round @click="OrderRefund">
            提交
          </van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { PolicyPayStatus, PolicyStatus } from '../../util/enum-data'
import { CHECK_MOBILE_PHONE } from '@/util/validate'
import { MobileRefund } from '@/api/refund.js'
import { GetVerificationCode } from '@/api/user'
import { gethttpurl } from '@/util/tools'
export default {
  name: 'InsuranceQueryPolicyDetail',
  components: {},
  mixins: [],
  props: {},

  data() {
    return {
      channelSignCode: gethttpurl('channelSignCode'),
      policyData: {},
      refundFlag: false,
      captcha: '',
      isDisable: false,
      currentRefundInfo: {},
      appntMobileNumber: '',
      errMsg: {
        mobilePhone: '',
        captcha: ''
      },
      captchaText: '获取验证码'
    }
  },

  computed: {},

  watch: {},

  created() { },

  mounted() {
    let str = sessionStorage.getItem('policyList')
    if (str) {
      this.policyData = JSON.parse(str) || {}
      console.log(this.policyData)
    } else {
      this.$router.push({ path: '/insured-query' })
    }
  },
  destroyed() { },

  filters: {
    userMobileHide(val) {
      return val ? val.substr(0, 3) + '****' + val.substr(7, 4) : ''
    },
    userCardNoHide(val) {
      return val ? val.substr(0, 6) + '********' + val.substr(-4) : ''
    },
    payStatus(val) {
      return PolicyPayStatus[val] || ''
    },
    policyStatus(val) {
      return PolicyStatus[val] || ''
    },
    shortDate(val) {
      if (!val) {
        return ''
      }
      const reg = new RegExp('-', 'g')
      return (val = val.substr(0, 10).replace(reg, '.'))
    }
  },

  methods: {
    checkPhone() {
      if (!this.appntMobileNumber) {
        this.errMsg.mobilePhone = '请填写手机号码！'
        return false
      } else if (!CHECK_MOBILE_PHONE(this.appntMobileNumber)) {
        this.errMsg.mobilePhone = '手机号格式不正确！'
        return false
      } else {
        this.errMsg.mobilePhone = ''
        return true
      }
    },
    checkVeriCode() {
      if (!this.captcha) {
        this.errMsg.captcha = '验证码必填！'
        return false
      }
      this.errMsg.captcha = ''
      return true
    },
    async sendVeriCode() {
      if (!this.appntMobileNumber) {
        this.$notify({ type: 'danger', message: '请填写手机号' })
        return
      }
      if (!CHECK_MOBILE_PHONE(this.appntMobileNumber)) {
        this.$notify({ type: 'danger', message: '手机号格式不正确' })
        return
      }
      if (this.isDisable) {
        return
      }
      this.confirmsf()
    },
    async confirmsf() {
      try {
        // beforeCaptcha: this.sms
        await GetVerificationCode({ mobilePhone: this.appntMobileNumber })
        this.captchaText = '获取中...'
        this.isDisable = true
        let countDown = 60
        this.captchaText = `重新获取(${countDown})`
        this.veriInterval = setInterval(() => {
          countDown = countDown - 1
          if (countDown === 0) {
            clearInterval(this.veriInterval)
            this.isDisable = false
            this.captchaText = `获取验证码`
          } else {
            this.captchaText = `重新获取(${countDown})`
          }
        }, 1000)
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    // 退款
    refundBtn() {
      this.$dialog
        .alert({
          message:
            '确认要退单吗？退单您将会失去保额300万的湖南爱民保补充医疗保障',
          showCancelButton: true,
          confirmButtonText: '继续退单',
          cancelButtonText: '手滑点错'
        })
        .then(() => {
          // on confirm
          this.currentRefundInfo = {}
          this.refundFlag = true
          this.currentRefundInfo = this.policyData
        })
    },
    async OrderRefund() {
      if (!this.appntMobileNumber) {
        this.$toast('手机号不能为空')
        return false
      }
      if (!this.captcha) {
        this.$toast('验证码不能为空')
        return false
      }
      const loading = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '退款中...'
      })
      const obj = {
        amount: process.env.VUE_APP_BUILD_TARGET === 'prod' ? 29 : 0.01,
        refundPersonId: this.currentRefundInfo.userInsurePersonList[0]
          .userInsurePersonId,
        insuranceId: this.currentRefundInfo.insuranceId,
        appntMobileNumber: this.appntMobileNumber,
        captcha: this.captcha
      }
      try {
        const res = await MobileRefund(obj)
        console.log('退款结果', res)
        this.$toast('退款成功')
        this.refundFlag = false
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      } finally {
        loading.clear()
      }
    },
    async getPersonPolicyPdf() {
      location.href = this.policyData.policyPdfUrl
    }
  }
}
</script>

<style scoped lang="scss">
.policy-detail-box {
  min-height: 100vh;
  background: #f5f6f7;
}

.policy-detail-content {
  min-height: 100vh;
  padding: 0;
}

.btn-group {
  display: flex;

  div {
    color: #fff;
    text-align: center;
    font-size: px2rem(16, 375);
    line-height: 2.5;
    background: linear-gradient(45deg, #ff6c61, #db0003);
    border-radius: px2rem(25, 375);
  }

  .btn-div {
    flex-basis: 49.5%;
    flex-grow: 1;
    margin: 1rem;
    color: #fff;
    text-align: center;
    font-size: px2rem(16, 375);
    line-height: 2.5;
    background: linear-gradient(to right, #db0003 0%, #ff6c61 100%);
    border-radius: px2rem(25, 375);
  }
}

.detail-title {
  color: #4c4c4c;
  padding-top: px2vw(23);
  padding-left: px2vw(28);
  background-color: #fff;
  margin-bottom: 20px;

  .detail-policy-status {
    height: px2vw(118);
    line-height: px2vw(118);
    font-size: px2rem(86);
    font-weight: 400;
  }

  .expiry-date {
    height: px2vw(95);
    margin-top: xvw(20);
  }
}

.detail-list.van-cell-group {
  color: #333;
  background-color: #fff;
  margin-bottom: px2vw(50);

  .van-cell {
    background: none !important;
    border-bottom: 1px solid #e8e8e8;

    &::after {
      left: 0px;
      border-color: #f6f6f6;
    }

    &:last-child {
      border: none;
    }

    &:nth-child(4) {
      .black-text {
        color: #333;
      }
    }
  }

  .van-cell__value {
    text-align: left;
  }
}

.margin-bottom-none {
  margin-bottom: 0 !important;
}

.head-icon {
  vertical-align: bottom;
  width: px2rem(81);
}

.rder-role {
  display: inline-block;
  margin-left: px2vw(28);
  font-size: px2rem(63);
  font-weight: 500;
  color: #000;
}

.van-cell__title {
  color: #4c4c4c;
  flex-basis: 30% !important;
}

.oblong .van-cell__title::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: px2vw(10);
  height: px2vw(46);
  background: linear-gradient(#6ab8e4, #169ce5);
  border-radius: px2vw(10);
}

.van-cell__value {
  flex-basis: 70% !important;
}

.cell-title-text {
  font-size: px2rem(46);
  font-weight: 500;
}

.black-text {
  color: #4c4c4c;
  font-weight: 400;
}

.fullname span {
  letter-spacing: 13px;
}

.refund-comtent {
  width: 90%;
  max-width: 750px;
  padding: px2rem(40, 750) px2rem(20, 750);
  background-color: #fff;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: px2rem(20, 750);

  .refund-title {
    margin-bottom: px2rem(20, 750);
    font-size: px2rem(36, 750);
    text-align: center;
  }

  .code-btn {
    margin-left: px2rem(25, 750);
    background: linear-gradient(to bottom, #ff8876 0%, #ff5041 100%);
    outline: none;
    border: none;
  }

  .disable-btn {
    background: #aaa;
    color: #fff;
    border: 1px solid transparent;
  }

  .refund-btn-group {
    padding-top: px2rem(20, 750);
    display: flex;
    justify-content: space-between;

    .submit-btn {
      width: 40%;
      border: none;
      outline: none;
      color: #fff;
      font-size: px2rem(16, 375);
      background: linear-gradient(to right, #db0003, #ff6c61);
    }

    .cancel-btn {
      width: 40%;
      font-size: px2rem(16, 375);
    }
  }
}
</style>
